import PricingTable from "@/components/PricingTable";
import FinalCTA from "@/components/FinalCTA";
import { Eyebrow, FadeIn, PageHero, usePageMeta } from "@/components/blocks";

const FAQS = [
  {
    q: "Which tier is right for me?",
    a: "Your live movement assessment defines the goal and complexity. Dedicated Coach covers most clients; Head Coach Elite is reserved for Grade 1/2 injury recovery, executive desk health and elite HYROX or marathon preparation.",
  },
  {
    q: "Can I change tiers later?",
    a: "Yes. Clients move between Dedicated Coach and Head Coach Elite between billing cycles as their needs change.",
  },
  {
    q: "Is live virtual coaching as effective as in-person?",
    a: "Every session is coached live on camera — your coach watches every rep and corrects you in real time. That is the difference from apps, PDFs and templates.",
  },
  {
    q: "Do you coach clients outside India?",
    a: "Yes. Live 1:1 sessions are delivered across international time zones, with pricing available in INR and USD.",
  },
];

export default function Pricing() {
  usePageMeta(
    "Pricing | StrengthLeap Coaching",
    "Group, Personal and Head Coach coaching options. India and international pricing — determined by your assessment, goals and coaching level."
  );

  return (
    <main>
      <PageHero
        testid="pricing-page"
        eyebrow="Pricing"
        lines={["Real coaching.", "Real time."]}
        copy="Two tiers of live, private 1:1 video coaching. Fixed monthly pricing, confirmed after your live movement assessment."
      />
      <PricingTable showHeading={false} />

      <section className="bg-bone px-6 pb-28 text-ink sm:px-10 lg:px-16">
        <div className="mx-auto max-w-[1440px]">
          <FadeIn>
            <Eyebrow tone="ink">Questions</Eyebrow>
          </FadeIn>
          <div className="mt-10">
            {FAQS.map((f, i) => (
              <FadeIn key={f.q} delay={i * 0.05}>
                <div className="grid gap-3 border-t border-ink/15 py-8 last:border-b sm:grid-cols-[1fr_1.4fr] sm:gap-10">
                  <h3 className="font-display text-xl font-black uppercase tracking-tight sm:text-2xl">{f.q}</h3>
                  <p className="max-w-xl text-sm leading-relaxed text-smoke sm:text-base">{f.a}</p>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      <FinalCTA />
    </main>
  );
}
